var _excluded = ["defaultOpen"];
var _X;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import S, { Fragment as w, createContext as I, useContext as L, useEffect as F, useMemo as g, useReducer as N, useRef as E } from "react";
import { match as O } from '../../utils/match.js';
import { forwardRefWithAs as k, render as M, Features as _ } from '../../utils/render.js';
import { optionalRef as G, useSyncRefs as x } from '../../hooks/use-sync-refs.js';
import { useId as K } from '../../hooks/use-id.js';
import { Keys as y } from '../keyboard.js';
import { isDisabledReactIssue7711 as W } from '../../utils/bugs.js';
import { OpenClosedProvider as $, State as v, useOpenClosed as q } from '../../internal/open-closed.js';
import { useResolveButtonType as z } from '../../hooks/use-resolve-button-type.js';
import { getOwnerDocument as J } from '../../utils/owner.js';
import { useEvent as R } from '../../hooks/use-event.js';
var Q = function (o) {
    return o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o;
  }(Q || {}),
  V = function (n) {
    return n[n.ToggleDisclosure = 0] = "ToggleDisclosure", n[n.CloseDisclosure = 1] = "CloseDisclosure", n[n.SetButtonId = 2] = "SetButtonId", n[n.SetPanelId = 3] = "SetPanelId", n[n.LinkPanel = 4] = "LinkPanel", n[n.UnlinkPanel = 5] = "UnlinkPanel", n;
  }(V || {});
var X = (_X = {}, _defineProperty(_X, 0, function _(e) {
    var _O;
    return _objectSpread(_objectSpread({}, e), {}, {
      disclosureState: O(e.disclosureState, (_O = {}, _defineProperty(_O, 0, 1), _defineProperty(_O, 1, 0), _O))
    });
  }), _defineProperty(_X, 1, function _(e) {
    return e.disclosureState === 1 ? e : _objectSpread(_objectSpread({}, e), {}, {
      disclosureState: 1
    });
  }), _defineProperty(_X, 4, function _(e) {
    return e.linkedPanel === !0 ? e : _objectSpread(_objectSpread({}, e), {}, {
      linkedPanel: !0
    });
  }), _defineProperty(_X, 5, function _(e) {
    return e.linkedPanel === !1 ? e : _objectSpread(_objectSpread({}, e), {}, {
      linkedPanel: !1
    });
  }), _defineProperty(_X, 2, function _(e, t) {
    return e.buttonId === t.buttonId ? e : _objectSpread(_objectSpread({}, e), {}, {
      buttonId: t.buttonId
    });
  }), _defineProperty(_X, 3, function _(e, t) {
    return e.panelId === t.panelId ? e : _objectSpread(_objectSpread({}, e), {}, {
      panelId: t.panelId
    });
  }), _X),
  B = /*#__PURE__*/I(null);
B.displayName = "DisclosureContext";
function h(e) {
  var t = L(B);
  if (t === null) {
    var o = new Error("<".concat(e, " /> is missing a parent <Disclosure /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(o, h), o;
  }
  return t;
}
var H = /*#__PURE__*/I(null);
H.displayName = "DisclosureAPIContext";
function j(e) {
  var t = L(H);
  if (t === null) {
    var o = new Error("<".concat(e, " /> is missing a parent <Disclosure /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(o, j), o;
  }
  return t;
}
var U = /*#__PURE__*/I(null);
U.displayName = "DisclosurePanelContext";
function Y() {
  return L(U);
}
function Z(e, t) {
  return O(t.type, X, e, t);
}
var ee = w,
  te = k(function (t, o) {
    var _O2;
    var _t$defaultOpen = t.defaultOpen,
      l = _t$defaultOpen === void 0 ? !1 : _t$defaultOpen,
      i = _objectWithoutProperties(t, _excluded),
      s = "headlessui-disclosure-button-".concat(K()),
      n = "headlessui-disclosure-panel-".concat(K()),
      u = E(null),
      D = x(o, G(function (f) {
        u.current = f;
      }, t.as === void 0 || t.as === w)),
      T = E(null),
      m = E(null),
      c = N(Z, {
        disclosureState: l ? 0 : 1,
        linkedPanel: !1,
        buttonRef: m,
        panelRef: T,
        buttonId: s,
        panelId: n
      }),
      _c = _slicedToArray(c, 2),
      p = _c[0].disclosureState,
      a = _c[1];
    F(function () {
      return a({
        type: 2,
        buttonId: s
      });
    }, [s, a]), F(function () {
      return a({
        type: 3,
        panelId: n
      });
    }, [n, a]);
    var P = R(function (f) {
        a({
          type: 1
        });
        var C = J(u);
        if (!C) return;
        var A = function () {
          return f ? f instanceof HTMLElement ? f : f.current instanceof HTMLElement ? f.current : C.getElementById(s) : C.getElementById(s);
        }();
        A == null || A.focus();
      }),
      b = g(function () {
        return {
          close: P
        };
      }, [P]),
      r = g(function () {
        return {
          open: p === 0,
          close: P
        };
      }, [p, P]),
      d = {
        ref: D
      };
    return /*#__PURE__*/S.createElement(B.Provider, {
      value: c
    }, /*#__PURE__*/S.createElement(H.Provider, {
      value: b
    }, /*#__PURE__*/S.createElement($, {
      value: O(p, (_O2 = {}, _defineProperty(_O2, 0, v.Open), _defineProperty(_O2, 1, v.Closed), _O2))
    }, M({
      ourProps: d,
      theirProps: i,
      slot: r,
      defaultTag: ee,
      name: "Disclosure"
    }))));
  }),
  ne = "button",
  le = k(function (t, o) {
    var _h = h("Disclosure.Button"),
      _h2 = _slicedToArray(_h, 2),
      l = _h2[0],
      i = _h2[1],
      s = Y(),
      n = s === null ? !1 : s === l.panelId,
      u = E(null),
      D = x(u, o, n ? null : l.buttonRef),
      T = R(function (r) {
        var d;
        if (n) {
          if (l.disclosureState === 1) return;
          switch (r.key) {
            case y.Space:
            case y.Enter:
              r.preventDefault(), r.stopPropagation(), i({
                type: 0
              }), (d = l.buttonRef.current) == null || d.focus();
              break;
          }
        } else switch (r.key) {
          case y.Space:
          case y.Enter:
            r.preventDefault(), r.stopPropagation(), i({
              type: 0
            });
            break;
        }
      }),
      m = R(function (r) {
        switch (r.key) {
          case y.Space:
            r.preventDefault();
            break;
        }
      }),
      c = R(function (r) {
        var d;
        W(r.currentTarget) || t.disabled || (n ? (i({
          type: 0
        }), (d = l.buttonRef.current) == null || d.focus()) : i({
          type: 0
        }));
      }),
      p = g(function () {
        return {
          open: l.disclosureState === 0
        };
      }, [l]),
      a = z(t, u),
      P = t,
      b = n ? {
        ref: D,
        type: a,
        onKeyDown: T,
        onClick: c
      } : {
        ref: D,
        id: l.buttonId,
        type: a,
        "aria-expanded": t.disabled ? void 0 : l.disclosureState === 0,
        "aria-controls": l.linkedPanel ? l.panelId : void 0,
        onKeyDown: T,
        onKeyUp: m,
        onClick: c
      };
    return M({
      ourProps: b,
      theirProps: P,
      slot: p,
      defaultTag: ne,
      name: "Disclosure.Button"
    });
  }),
  oe = "div",
  re = _.RenderStrategy | _.Static,
  se = k(function (t, o) {
    var _h3 = h("Disclosure.Panel"),
      _h4 = _slicedToArray(_h3, 2),
      l = _h4[0],
      i = _h4[1],
      _j = j("Disclosure.Panel"),
      s = _j.close,
      n = x(o, l.panelRef, function (p) {
        i({
          type: p ? 4 : 5
        });
      }),
      u = q(),
      D = function () {
        return u !== null ? u === v.Open : l.disclosureState === 0;
      }(),
      T = g(function () {
        return {
          open: l.disclosureState === 0,
          close: s
        };
      }, [l, s]),
      m = t,
      c = {
        ref: n,
        id: l.panelId
      };
    return /*#__PURE__*/S.createElement(U.Provider, {
      value: l.panelId
    }, M({
      ourProps: c,
      theirProps: m,
      slot: T,
      defaultTag: oe,
      features: re,
      visible: D,
      name: "Disclosure.Panel"
    }));
  }),
  Oe = Object.assign(te, {
    Button: le,
    Panel: se
  });
export { Oe as Disclosure };